require('./index.sass');
require('./component-input');

module.exports = 'component-input';


/*****************
 ** WEBPACK FOOTER
 ** ./~/component-input/src/index.js
 ** module id = 353
 ** module chunks = 1
 **/